import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowUpRight, ArrowRight } from 'lucide-react';
import { BLOG_POSTS } from '../mock';
import Reveal from './Reveal';

const POPULAR_SLUGS = [
  'halloween-dia-de-los-muertos-flowers',
  'redwood-city-ca-florist-new-location',
  'thanksgiving-centerpiece-guide',
  'flower-delivery-cost-guide',
];

export const PopularPosts = () => {
  const posts = POPULAR_SLUGS.map((s) => BLOG_POSTS.find((p) => p.slug === s)).filter(Boolean);

  return (
    <section data-testid="popular-posts-section" className="py-20 lg:py-28 bg-[#F7F3EB]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-10">
            <div>
              <p className="text-[13px] tracking-[0.2em] uppercase text-[#C4715A] font-medium">From the Journal</p>
              <h2 className="mt-3 font-serif-display text-3xl md:text-4xl text-[#26302a] leading-tight">Guides our neighbors read most</h2>
            </div>
            <Link to="/blog" data-testid="popular-posts-view-all" className="inline-flex items-center gap-2 text-[15px] font-medium text-[#3D5142] hover:text-[#C4715A] transition-colors shrink-0">
              View all articles <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {posts.map((post, i) => (
            <Reveal key={post.slug} delay={i * 80}>
              <Link to={`/blog/${post.slug}`} data-testid={`popular-post-${post.slug}`} className="group flex flex-col h-full bg-white rounded-2xl overflow-hidden border border-[#EFE8DD] hover:shadow-[0_20px_50px_rgba(61,81,66,0.15)] hover:-translate-y-1.5 transition-all duration-500">
                <div className="overflow-hidden aspect-[16/10] bg-[#F4EFE7]">
                  <img src={post.heroImg} alt={post.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <h3 className="font-serif-display text-[19px] text-[#2A2A28] leading-snug group-hover:text-[#C4715A] transition-colors">{post.title}</h3>
                  <div className="mt-auto pt-4 flex items-center justify-between text-[13px] text-[#8A7C6A]">
                    <span className="inline-flex items-center gap-1.5"><Clock className="w-3.5 h-3.5" /> {post.readTime}</span>
                    <ArrowUpRight className="w-4 h-4 text-[#3D5142] group-hover:text-[#C4715A] transition-colors" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularPosts;
